import moment from 'moment';

export default function toDatetime(date) {
    if (date) {
        return moment(date).locale('en').format('MM/DD/YYYY hh:mm A');
    }
}
